module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0055.jpg?v=03795814";